// Utils
import { formatTimestampToYMD } from "utils/format";

// Const
import { firmwareAvailabilitiesLabels } from '../const';

export const getSupportListSendRequestParams = ({
  auth,
}) => {
  const isStandaloneMode = !auth.orgs || Object.keys(auth.orgs).length === 0;
  const apiBaseUrl = isStandaloneMode ? `/orgs/:orgId` : `/ents/:entId/orgs/:orgId`;
  const apiPaths = {
    org: `${apiBaseUrl}/firmware/supportList.read`,
    site: `${apiBaseUrl}/firmware/supportList.read`
  };
  const apiKey = apiPaths[auth.scopeLevel];

  const restfulParamsConfig = {
    standalone: {
      orgId: auth.realm?.id,
      siteId: auth.sites?.id,
    },
    nonStandalone: {
      entId: auth.realm?.id,
      orgId: auth.realm?.id,
      siteId: auth.sites?.id,
    },
  };

  const restfulParams = isStandaloneMode ? restfulParamsConfig["standalone"] : restfulParamsConfig["nonStandalone"];

  return {
    apiKey,
    restfulParams
  };
}

// {
//   [serialName]: {
//     [fw1, fw2, ...]
//   }
// }
export const getFirmwareListMap = ({
  firmwareList
}) => {
  return firmwareList.reduce((acc, fw) => {
    const serialName = fw?.serialName;
    const hw = fw?.hwVersion;

    if (serialName && hw) {
      const combinedKey = serialName + "-" + hw;
      return {
        ...acc,
        [combinedKey]: acc[combinedKey] ? [...acc[combinedKey], fw] : [fw],
      };
    } else {
      return acc;
    }
  }, {});
}

export const initSupportListTableData = ({
  responseData = []
}) => {
  let accessPoints = [];
  let switches = [];
  let routers = [];

  if (responseData && responseData.length > 0) {
    const firmwareListMap = getFirmwareListMap({ firmwareList: responseData });

    const all = Object.values(firmwareListMap)
      .flatMap(matchedFwList => {
        const fw = matchedFwList[0];

        if (fw) {
          return [{
            ...fw,
            releaseDateYMD: fw?.releaseDate ? formatTimestampToYMD(fw.releaseDate) : "-",
            firmwareList: matchedFwList || [],
            firmwareAvailabilitiesLabel: fw?.firmwareAvailability ? (firmwareAvailabilitiesLabels[fw.firmwareAvailability] ?? fw.firmwareAvailability) : "-",
          }]
        } else {
          return [];
        }

      })

    all.forEach(fw => {
      if (fw.deviceType === "ap") accessPoints.push(fw);
      else if (fw.deviceType === "switch") switches.push(fw);
      else if (fw.deviceType === "router") routers.push(fw);
    })
  }

  return {
    accessPoints,
    switches,
    routers
  };
}